// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qEBz","type":"styles_type__3HbxT","choices":"styles_choices__3SRkR"};